// Cross-cutting UI state for overlays that are opened from one place and
// rendered in another (topbar → mini cart, product card → quick view,
// keyboard → command palette). Only open/close flags live here; the
// overlays own their own data.
import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    miniCartOpen: false,
    quickViewId: null as string | null,
    paletteOpen: false,
  }),
  actions: {
    openMiniCart() {
      this.miniCartOpen = true;
    },
    closeMiniCart() {
      this.miniCartOpen = false;
    },
    openQuickView(productId: string) {
      this.quickViewId = productId;
    },
    closeQuickView() {
      this.quickViewId = null;
    },
    openPalette() {
      this.paletteOpen = true;
    },
    closePalette() {
      this.paletteOpen = false;
    },
  },
});
